import React, { useEffect, useState, useContext } from "react";
import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import DOMPurify from "isomorphic-dompurify";
import { useSelector } from "react-redux";

import Radio from "components/common/radio";
import {
  Wrapper,
  PlanName,
  Description,
  Price,
  GarageType,
  DescriptionPointer,
  DesciptionPoint
} from "./styles";
import CloneChildren from "@components/children";
import Badge from "@components/common/badge";

import { CommonProps } from "@utils/interface";
import { IBadge } from "@components/common/badge";
import Hyperlink from "@components/common/hyperlink";

import { Context } from "@components/useContext/context";
import TickIcon from "@public/images/tick-yes.svg";
import FastagNudge from "../common/fastagNudge/index";
import { getJourneyType } from "@utils/index";

interface IPlansCard extends CommonProps {
  description: string;
  planName: string;
  premium: string | number;
  isSelected: boolean;
  badge: IBadge;
  variantsLength?: any;
  planId: string;
  garageType?: string;
  strikeOffPrice?: string | number;
  isVariant: boolean;
  showLearnMore?: boolean;
  category?: string;
  disabled?: boolean;
  pseudoDiscount?: "string";
  planVariantDescription: Array<any>;
  fastagTitle?: string;
  showFastag: boolean;
}

const PlanCard = ({ children, ...props }: IPlansCard) => {
  const {
    description,
    planName,
    premium,
    actions,
    isSelected,
    badge,
    variantsLength,
    planId,
    garageType,
    strikeOffPrice,
    isVariant,
    showLearnMore,
    category,
    disabled,
    pseudoDiscount,
    styles,
    planVariantDescription = []
  } = props;

  
  const { isDesktop } = useContext(Context);

  const { on_click, learn_more_on_click } =
    actions || {};

  const { selectedPlanId, selectedCategory } = useSelector(
    ({ globalState }: any) => {
      return {
        selectedPlanId: globalState?.plan_id,
        selectedCategory: globalState?.category
      };
    }
  );


  const [isPlanSelected, setIsPlanSelected] = useState(false);

  useEffect(() => {
    if (!selectedPlanId && !selectedCategory) {
      setIsPlanSelected(isSelected);
    } else {
      if (category && selectedCategory) {
        setIsPlanSelected(selectedCategory === category);
      } else {
        setIsPlanSelected(planId === selectedPlanId);
      }
    }
  }, [selectedPlanId, selectedCategory]);

  const handleClick = () => {
    if (!disabled) {
      if (on_click?.[0] && typeof on_click[0].funCall === "function") {
        on_click?.forEach((eachFunc: any) => {
          eachFunc.funCall(eachFunc.args);
        });
      }
    }
  };

  return (
    <Wrapper
      onClick={() => {
        handleClick();
      }}
      isSelected={isPlanSelected}
      styles={styles}
    >
      <Box style={{ padding: "0px 1rem 0px", width: "auto" }}>
        <Flex justifyContent="space-between" alignItems="baseline">
          <Flex flexDirection="column">
            {badge?.text && (
              <Badge
                type={badge?.type}
                image={{
                  imgSrc: badge?.image,
                  height: 16,
                  width: 16,
                  alt: ""
                }}
                text={badge?.text}
                is_visible={true}
                styles={{ marginBottom: "12px" }}
              />
            )}
            {planName && (
              <PlanName disabled={disabled} isVariant={isVariant}>
                {planName}
                {isVariant && garageType && ":"}
              </PlanName>
            )}
            {isVariant && garageType && (
              <GarageType disabled={disabled}>{garageType}</GarageType>
            )}{" "}
          </Flex>
          {!disabled && (
            <Radio isSelected={isPlanSelected} size={isDesktop ? 20 : 16} />
          )}
        </Flex>
        
        {planId !== "car_tp" && !garageType && getJourneyType() === "fresh_car" && (
           <FastagNudge
            actions={actions}
            is_visible={true}
          />
        )}
        {!disabled && (
          <>
            <Price>
              {variantsLength > 1 && (
                <span style={{ marginBottom: "4px" }}>
                  {variantsLength} options starting from
                </span>
              )}
              <div>
                ₹{premium}{" "}
                {planId === "car_tp" && (
                  <span style={{ marginLeft: "8px" }}>
                    (Same price across all insurers)
                  </span>
                )}
                {strikeOffPrice && (
                  <span
                    style={{
                      textDecoration: "line-through",
                      fontSize: "14px",
                      marginLeft: "8px"
                    }}
                  >
                    ₹{strikeOffPrice}
                  </span>
                )}
                {pseudoDiscount && (
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      color: "#0FA457",
                      marginLeft: "14px"
                    }}
                  >
                    {pseudoDiscount}
                  </span>
                )}
              </div>
            </Price>
            {description ? (
              <Description
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(description)
                }}
              />
            ) : null}
            {planVariantDescription?.length > 0
              ? planVariantDescription?.map((descriptionPoint) => {
                  return (
                    <DescriptionPointer>
                      <Box width="20px">
                        <TickIcon />
                      </Box>
                      <DesciptionPoint
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(descriptionPoint)
                        }}
                      />
                    </DescriptionPointer>
                  );
                })
              : null}
            {showLearnMore && (
              <Hyperlink
                clickHandler={() => {
                  if (
                    learn_more_on_click?.[0] &&
                    typeof learn_more_on_click[0].funCall === "function"
                  ) {
                    learn_more_on_click?.forEach((eachFunc: any) => {
                      eachFunc.funCall(eachFunc.args || {});
                    });
                  }
                }}
                type="UNDERLINE"
                is_visible={true}
                text="Learn more"
                styles={{ display: "inline-block", width: "max-content", marginLeft: "2px" }}
              />
            )}
          </>
        )}
      </Box>

      <Box style={{ padding: "0px 1rem 0px", width: "auto" }}>
        <CloneChildren children={children} props={props} />
      </Box>
    </Wrapper>
  );
};

export default PlanCard;
